<template>
  <div class="payment-button_block">
    <div class="left">
      <ButtonWithDescriptionBox
        :link="{name: 'VerifyingCustomAccount', params: null}"
        description="入金に必要なアカウントの情報を登録できます。"
        button-name="入金用アカウント登録"
        button-color="orange"/>
      <ButtonWithDescriptionBox
        v-if="isStripeAccountFull"
        :link="{name: 'PayoutBalances', params: null}"
        description="入金用アカウントの残高を確認・銀行口座への出金ができます。"
        button-name="受注報酬確認・出金"
        button-color="yellow"/>
    </div>
    <div class="right">
      <ButtonWithDescriptionBox
        :link="{name: 'RegistrationBank', params: null}"
        description="入金用の銀行口座情報を登録できます。"
        button-name="口座情報登録"
        button-color="orange"/>
      <ButtonWithDescriptionBox
        v-if="isStripeAccountFull"
        :link="{name: 'PayoutLogs', params: null}"
        description="クライアントからの支払い・銀行口座への入出金履歴を確認できます。"
        button-name="入出金履歴"
        button-color="blue"/>
    </div>
  </div>
</template>

<script>
  import ButtonWithDescriptionBox from "@/components/molecules/box/button/ButtonWithDescriptionBox";

  export default {
    name: "PaymentButtonBlock",

    components: {ButtonWithDescriptionBox},

    props: {
      operatorStripe: {
        type: Object,
        required: true
      }
    },

    computed: {
      isStripeAccountFull() {
        return this.operatorStripe.accountId !== null && this.operatorStripe.bankId !== null
          && ((this.operatorStripe.companyId !== null && this.operatorStripe.personId !== null) || this.operatorStripe.individualId !== null)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .payment-button_block {
    @include double_columns($left: 40%, $right: 40%);

    .button-with-description-box {
      margin-top: 2rem;
    }
  }
</style>
